<template>
  <div class="rule-wrap" id="scrollDiv" ref="scrollDiv">
    <div class="section-1">
        <img src="../../../src/assets/images/winterGame/rule/ruleTitle.png">
    </div>
    <div class="rule-text">
      <div class="rule-title">什么是点券？</div>
      <p>点券是：23年秋季24寒假打地基高活激励政策内第四个奖项“松鼠杯团队赛优胜奖”的奖励额，包含裂变金，期权及备货款费用减免额。</p>
      <p class="linkTitle" @click="showFile">23年秋季24寒假打地基高活激励政策</p>
      <div class="rule-title">如何获得点券？</div>
      <p class="subTitle">即松鼠杯团队赛优胜奖的奖项和规则，具体细则如下：</p>
    </div>
    <div class="section-2">
      <img src="../../../src/assets/images/winterGame/rule/daily.png">
    </div>
    <div class="section-3">
      <img src="../../../src/assets/images/winterGame/rule/awardDetails.png">
    </div>
    <van-popup v-model="fileDialog">
      <div class="swipe-wrap">
        <van-swipe class="my-swipe" @change="onChange" :autoplay="0" indicator-color="white">
          <van-swipe-item>
            <img src="../../../src/assets/images/ddj/highActivity/redfile1.png" /> 
          </van-swipe-item>
          <van-swipe-item>
            <img src="../../../src/assets/images/ddj/highActivity/redfile2.png" />
          </van-swipe-item>
        </van-swipe>
        <div class="indicator">
          <div class="custom-indicator">{{ current + 1 }}/2</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileDialog: false,
      current: 0,
    };
  },
  created() {
      document.title = this.$route.meta.title || '松鼠杯'
  },
  mounted() {
    let { c, f, s } = this.$route.query;
    this.campusId = c;
    this.followUserId = f;
    this.sourceName = s;
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    showFile(){
      this.fileDialog = true;
    },
    handleScrollTop() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  },
};
</script>

<style lang="less" scoped>
.swipe-wrap{
  position: relative;
  .indicator{
    position: absolute;
    bottom: 0;
    right: 0;
    .custom-indicator{
      text-align: right;
    }
  }
}


.my-swipe {
  width: 85vw;
  img{
    width:100%;
    height: auto;
  }
}

.rule-wrap {
  padding-bottom: 60px;
  .section-1 {
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
  .rule-text {
    margin: 0 48px;
    .rule-title {
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #323232;
      line-height: 44px;
    }
    p {
      margin: 8px 0;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #323232;
    }
    .linkTitle {
      font-size: 30px;
      margin: 48px 0 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #58ABF6;
      text-decoration: underline;
    }
    .subTitle {
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .section-2 {
    margin: 40px 0;
    text-align: center;
    img {
      width: 90%;
    }
  }
  .section-3 {
    text-align: center;
    img {
      width: 90%;
    }
  }
}

</style>
